import React from 'react'
import PageTransition from 'gatsby-plugin-page-transitions'

import {Helmet} from 'react-helmet'

const NotFoundPage = () => (<PageTransition>
	<div className="Atrakeur-Page">
	  <Helmet>
	    <meta charSet="utf-8" />
	    <title>Atrakeur: DIY, Modélisme et Web</title>
	  </Helmet>

	  <div>
	    <h1>NOT FOUND</h1>
	    <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
	  </div>
	</div>
</PageTransition>)

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js